export default __webpack_public_path__ + "static/media/1.ce3222b3.png";